import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {globals} from '@returns-centre/globals';
import {store} from '@returns-centre/store';
import {clientApi} from '@/http/ClientApi';
import localStorage from 'local-storage-fallback';

@Module({name: 'appModule', namespaced: true})
export default class AppModule extends VuexModule {

    app_custom_width: string = '100%';

    countries: Country[] = [];

    get getCountries(): Country[] {
        return this.countries;
    }

    get hasCountries(): boolean {
        return this.countries.length > 0;
    }

    get appCustomWidth(): string {
        return this.app_custom_width;
    }

    get getCountryOptions(): CountryOption[] {

        let options = [];
        for (const row of this.countries) {
            options.push({
                label: row.name,
                id: row.id,
                code: row.code,
                name: row.name
            });
        }
        return options;
    }

    get hasCountryOptions(): boolean {
        return this.getCountryOptions.length > 0;
    }

    @Action
    async fetchCountries(): Promise<void> {
        let res = await clientApi.getCountries();
        this.context.commit('SET_COUNTRIES', res);
    }

    @Action
    setAppCustomWidth(width: string = '100%') {
        this.context.commit('SET_APP_CUSTOM_WIDTH', width);
    }

    @Action
    resolveSession(): void {
        this.context.commit('RESOLVE_SESSION');
    }

    @Mutation
    RESOLVE_SESSION(): void {
        const tradeInModule = store.state.tradeInModule;
        const customerModule = store.state.customerModule;
        let lsTradeInSession: (string | null) = localStorage.getItem(tradeInModule.ls_trade_in_session_key);
        let lsVerifiedOrderSession: (string | null) = localStorage.getItem(customerModule.verified_order_session_key);

        if (lsVerifiedOrderSession) {
            const verifiedOrderSession = JSON.parse(lsVerifiedOrderSession);
            if (verifiedOrderSession) {
                customerModule.verified_order = verifiedOrderSession || null;
            }
        }

        if (!lsTradeInSession) {
            return;
        }


        let tradeInSession = JSON.parse(lsTradeInSession);
        if (tradeInSession) {
            tradeInModule.trade_in_session = tradeInSession;
            let customer: ReturnsPortalShopifyCustomer = tradeInSession['trade_in_customer'];
            /** CHECK IF LOGGED IN CUSTOMERID != SESSION CUSTOMER ID
             THEN -- CLEAR THE SESSION AND - REDIRECT TO TRADE IN ITEMS PAGE
             */
            if (customer && customer.id != globals.logged_in_customer_id) {
                /** this means customer created the trade in but
                 after logged in with different account creds.
                 So remove the whole session and
                 ResolveRouteName methods will take care of correct redirection
                 */
                localStorage.removeItem(tradeInModule.ls_trade_in_session_key);
                return;
            }

            tradeInModule.trade_in_step = tradeInSession['trade_in_step'] || 1;
            tradeInModule.trade_in = tradeInSession['trade_in'] || null;
            tradeInModule.confirmed_trade_in = tradeInSession['confirmed_trade_in'] || null;
            tradeInModule.trade_in_items = tradeInSession['trade_in_items'] || null;
            tradeInModule.trade_in_address = tradeInSession['trade_in_address'] || null;
            tradeInModule.trade_in_shipping = tradeInSession['trade_in_shipping'] || null;
            tradeInModule.trade_in_price_deductions = tradeInSession['trade_in_price_deductions'] || [];
            customerModule.orders = tradeInSession['trade_in_customer_orders'] || [];
            tradeInModule.return_carrier_services = tradeInSession['trade_in_return_carrier_services'] || [];

            if (tradeInModule.trade_in_shipping) {
                tradeInModule.trade_in_address = tradeInModule.trade_in_shipping.trade_in_address || null;
                tradeInModule.trade_in_notification_email =
                    tradeInModule.trade_in_shipping.trade_in_notification_email || '';
                tradeInModule.selected_return_carrier_service =
                    tradeInModule.trade_in_shipping.trade_in_selected_return_carrier_service || null;
            }
        }
    }

    @Mutation
    SET_COUNTRIES(countries: Country[]): void {
        this.countries = countries;
    }

    @Mutation
    SET_APP_CUSTOM_WIDTH(width: string): void {
        this.app_custom_width = width;
    }

}
